import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { parseColor } from '../utils';
import { getCSSProperty } from '../../utils';

function stroke(_ref, theme) {
  var _stroke = _ref.stroke,
      _ref$strokeAlign = _ref.strokeAlign,
      strokeAlign = _ref$strokeAlign === void 0 ? 'outside' : _ref$strokeAlign,
      strokeOpacity = _ref.strokeOpacity,
      strokeWeight = _ref.strokeWeight,
      styles = _objectWithoutPropertiesLoose(_ref, ["stroke", "strokeAlign", "strokeOpacity", "strokeWeight"]);

  if (_stroke && strokeWeight) {
    var color = theme && theme.colors ? theme.colors[_stroke] ? getCSSProperty('colors', _stroke) : parseColor(_stroke) : parseColor(_stroke);
    var shadow = styles.boxShadow ? styles.boxShadow.split(', ') : [];

    if (strokeAlign === 'inside') {
      shadow.unshift("inset 0px 0px 0px " + strokeWeight + "px " + color);
    } else if (strokeAlign === 'outside') {
      shadow.unshift("0px 0px 0px " + strokeWeight + "px " + color);
    } else if (strokeAlign === 'center') {
      shadow.unshift("inset 0px 0px 0px " + strokeWeight / 2 + "px " + color);
      shadow.unshift("0px 0px 0px " + strokeWeight / 2 + "px " + color);
    }

    styles.boxShadow = shadow.join(', ');
  } else {
    styles.stroke = _stroke;

    if (strokeOpacity) {
      styles.strokeOpacity = strokeOpacity;
    }
  }

  return styles;
}

export default stroke;